/**
 * Countdowns time
 *
 * @author: Michał Skrzypek <michal[dot]skrzypek[at]studioworx[dot]co[dot]uk>
 */

(function ( $, _ ) { /* global _, JS_TRANSLATIONS, DEBUG, handlebarsTemplates */
	'use strict';

	/**
	 * @selector data-zg-role="countdown-timer" The plugin start for each selector in the dom when the page load
	 */

	var selector = '[data-zg-role="countdown-timer"]';

	// RETURN CLASS DEFINITION
	// =======================

	var CountdownTimer = function ( element, options ) {
		this.$element = $(element);
		this.options = options;
		
		this.$days = $('[data-zg-role="days"]', element);
		this.$hours = $('[data-zg-role="hours"]', element);
		this.$minutes = $('[data-zg-role="minutes"]', element);
		this.$seconds = $('[data-zg-role="seconds"]', element);
		this.$when = $('[data-zg-role="when"]', element);

		this.deadline = new Date();
		
		if (this.options.date) {
			var date = this.options.date.split('-');
			this.deadline.setFullYear(date[0],parseInt(date[1])-1,date[2]);
		}
		
		var hours = [14,0,0];
		if (this.options.time) {
			var hours = this.options.time.split(':');
		}
		this.deadline.setHours(hours[0],hours[1],hours[2],0);
				
		this._initializeClock();
	};

	/**
	 * @param {string} date
	 * @param {string} time
	 */

	CountdownTimer.DEFAULTS = {
		date: null,
		time: null,
		exclude: null,
		tomorrow: null,
		monday: null
	};

	/**
	 * _initializeClock
	 */
	CountdownTimer.prototype._initializeClock = function (self) {
		var self = this;
		if ( self.options.exclude ) {
			var exclude = self.options.exclude.split(',');
			var now = new Date();
			for ( var i=0; i < exclude.length; i++ ) {
				if ( now.getDay() == parseInt(exclude[i]) ) {
					self.$element.hide();
					return;
				}
			}
		}
		this._updateClock(self);
		this.timeinterval = setInterval(function(){
			self._updateClock(self);
		}, 1000);
	};
	
	/**
	 * _updateClock
	 */
	CountdownTimer.prototype._updateClock = function (self) {
		var t = self._getTimeRemaining(self);

		self.$days.html(('00' + t.days).slice(-2));
		if ( t.days == 0 ) self.$days.parent().hide();
		self.$hours.html(('00' + t.hours).slice(-2));
		self.$minutes.html(('00' + t.minutes).slice(-2));
		self.$seconds.html(('00' + t.seconds).slice(-2));
		var now = new Date();
		if ( now.getDay() == 5 ) self.$when.html(self.options.monday);
		else self.$when.html(self.options.tomorrow);

		if (t.total <= 0 || now.getDay() == 6 || now.getDay() == 7 ) {
			clearInterval(this.timeinterval);
			self.$element.hide();
		} else {
			self.$element.show();
		}
	};

	/**
	 * _getTimeRemaining
	 */
	CountdownTimer.prototype._getTimeRemaining = function (self) {
		var t = Date.parse(self.deadline) - Date.parse(new Date());
		var seconds = Math.floor((t / 1000) % 60);
		var minutes = Math.floor((t / 1000 / 60) % 60);
		var hours = Math.floor((t / (1000 * 60 * 60)) % 24);
		var days = Math.floor((t / (1000 * 60 * 60 * 24)));
		
		return {
			'total': t,
			'days': days,
			'hours': hours,
			'minutes': minutes,
			'seconds': seconds
		};
	};

	// RETURN PLUGIN DEFINITION
	// ========================

	function Plugin ( option ) {
		return this.each( function () {
			var $this = $( this );
			var data = $this.data( 'zg.countdown-timer' );
			var options = $.extend( {}, CountdownTimer.DEFAULTS, window.ZG_CONFIG || {}, $this.data(), typeof option === 'object' && option );

			if ( !data ) {
				$this.data( 'zg.countdown-timer', new CountdownTimer( this, options ) );
			}
		} );
	}

	$.fn.zgCountdownTimer = Plugin;
	$.fn.zgCountdownTimer.Constructor = CountdownTimer;

	// RETURN DATA-API
	// ===============
	
	/**
	 * @method document
	 * @listen document#zg.getProductInfo.productCreated  When product rendered by handlebars (like
	 *     in category page) start the plugin
	 */
	$( document ).on( 'zg.getProductInfo.productCreated', function ( e, element, options, product ) {
		if ( $( element ).find( selector ).length ) {
			var $element = $( element ).find( selector );
			Plugin.call( $element );
		}
	} );

	$( function () {
		$( selector ).each( function () {
			Plugin.call( $( this ) );
		} );
	} );

}( jQuery, _ ));
